var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-text',[_c('p',{staticClass:"text-center"},[_vm._v(" ©2021 Frclso "),(_vm.ishttps)?_c('a',{staticClass:"text-center",attrs:{"href":"https://beian.miit.gov.cn/","garget":"_blank"}},[_vm._v(" 粤ICP备2021036352号-1 ")]):_vm._e()])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }